import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import { resolvePublicWebOriginForBrowserOrBuild } from "@Front/Utils/deploymentSitePublicWebClient";

import { CguHeaderBody } from "./CguHeaderBody";

export function CGUHeader(): React.JSX.Element {
	const publicSiteOrigin = resolvePublicWebOriginForBrowserOrBuild();
	return (
		<section>
			<Typography typo={ETypo.TITLE_H4} color={ETypoColor.TEXT_PRIMARY}>
				Conditions Générales d&apos;Utilisation
			</Typography>
			<CguHeaderBody publicSiteOrigin={publicSiteOrigin} />
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_SECONDARY} italic>
				Dernière mise à jour le 24 avril 2024.
			</Typography>
		</section>
	);
}
